import { render, staticRenderFns } from "./InfoContainer.vue?vue&type=template&id=86cc66ec&scoped=true&"
import script from "./InfoContainer.vue?vue&type=script&lang=js&"
export * from "./InfoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cc66ec",
  null
  
)

export default component.exports